import { jsx as _jsx } from "react/jsx-runtime";
import { POPOVER_ANIMATION_DURATION } from '@as/cotopaxi';
import { AuthFormLocation } from '@as-react/common-types';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AuthenticationPopover } from '../components/account/authentication/AuthenticationPopover';
import { authActions } from '../redux/authentication/actions/AuthActions.creators';
import { makeGetLoginError, makeGetLoginLoading, makeGetResetPasswordState, } from '../redux/authentication/selectors/AuthSelectors';
export const AuthenticationContainer = ({ actionUri, anchorEl, onClose, registrationLink, }) => {
    const [forgotPasswordActive, setForgotPasswordActive] = useState(false);
    const dispatch = useDispatch();
    const loginError = useSelector(makeGetLoginError());
    const resetPasswordState = useSelector(makeGetResetPasswordState());
    const loading = useSelector(makeGetLoginLoading());
    const resetForgotPasswordState = () => {
        (resetPasswordState.success || resetPasswordState.error) &&
            dispatch(authActions.createResetCredentialsSuccessAction(null));
    };
    const toggleView = () => {
        setForgotPasswordActive(prev => !prev);
        resetForgotPasswordState();
    };
    const handleLoginSubmit = (values) => dispatch(authActions.login({
        username: values.email,
        password: values.password,
        keepSignedIn: values.keepSignedIn,
        reloadOnSuccess: true,
        location: AuthFormLocation.POPOVER,
    }));
    const handleClose = () => {
        onClose === null || onClose === void 0 ? void 0 : onClose();
        setTimeout(() => setForgotPasswordActive(false), POPOVER_ANIMATION_DURATION);
    };
    useEffect(() => {
        dispatch(authActions.createInitSocialAction());
    }, []);
    return (_jsx(AuthenticationPopover, { login: {
            action: actionUri,
            onSubmit: handleLoginSubmit,
            errorFeedback: loginError,
            loading: loading,
        }, forgotPassword: {
            onSubmit: values => dispatch(authActions.createResetCredentialsAction(values.email)),
            errorFeedback: resetPasswordState.error,
            successFeedback: resetPasswordState.success,
        }, anchorEl: anchorEl, onClose: handleClose, registrationLink: registrationLink, onAuthResetForm: () => dispatch(authActions.resetError()), forgotPasswordActive: forgotPasswordActive, toggleView: toggleView, onEmailChange: resetForgotPasswordState }));
};
